<div class="layout-wrapper" [ngClass]="containerClass">
  <app-navbar-page></app-navbar-page>
  <app-sidebar></app-sidebar>
  <div class="layout-main-container ml-0" style="padding-top: 28px; background-color: #E9E8EC;">    
    <div class="layout-main">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer-page></app-footer-page>
  <div class="layout-mask"></div>
</div>